import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'categoryLabel'
})
export class CategoryLabelPipe implements PipeTransform {

  private readonly labels: Record<string, string> = {
    'Adult': '12 yrs+', 'Children': '2–12 yrs', 'Infant': '15 days – 2 yrs'
  };
  
  transform(category: string): string {
    const baseCategory = category.replace(/\d+/g, '').trim();
    return this.labels[baseCategory] || baseCategory;
  }

}
